<template>
	<div class="preview-box">
		<div class="preview-title">{{ title }}</div>
		<div class="preview-content">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'PreviewBox',
	props: {
		title: { type: String },
		state: { type: Object },
	},
};
</script>

<style scoped lang="scss">
.preview-box {
	margin: 0 0 0 10px;
	border: var(--primary-border);
	border-radius: 7px;
	font-weight: 400;
	overflow: hidden;

	.preview-title {
		padding: 4px 6px;
		font-size: 12px;
		border-bottom: var(--primary-border);
		background-color: #f8f9fb;
	}

	.preview-content {
		padding: 6px;
		font-size: 14px;
	}
}
</style>
